module.exports = __webpack_public_path__ + "img/lotnisko2.4c445f6c.jpg";